// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsNotEmpty } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface IDeviceKey {
	id: string | undefined;

	dateCreated: string | undefined;

	datePrinted: string | undefined;

	deviceKey: string;

	$type?: string | undefined;
}
export class DeviceKey {
	constructor(data?: IDeviceKey) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.dateCreated) { this.dateCreated = new Date(data.dateCreated); }
		if (data.datePrinted) { this.datePrinted = new Date(data.datePrinted); }
	}

	id: string | undefined;

	dateCreated: Date | undefined = new Date();

	datePrinted: Date | undefined;

	@IsNotEmpty()
	deviceKey: string = "";

	static $type: string = "CoreApi.Models.DeviceKey, ";
	$type?: string | undefined = DeviceKey.$type;
}

